module.exports = __webpack_public_path__ + "static/media/Group 6505.272face9.svg";